<template>
    <el-dialog width="900px"  customClass="dialog_detail_style" :title="title" :visible.sync="show" @close='onCloseWindow' v-dialogDrag
       :append-to-body=appendToBody
    > 
        <slot></slot>
        <slot name="footer"></slot>
    </el-dialog>
</template> 

<script>
export default {
    props:{ 
        title:{
            Type:String,
            default(){
                return "window"
            }
        },
        appendToBody:{
            Type:Boolean,
            default(){
                return false
            }
        },        
        defaultShow:{
            Type:Boolean,
            default(){
                return false
            }
        }
    }, 
    watch:{
        defaultShow(value){
           this.show=value;
           if(this.show == true){
               this.$emit("onInitData",this.show);
           }
        },
        appendToBody(newValue,oldVal){
            this.toBody=newValue;
        }
    },  
    // inject: [title], 
    methods:{
        /**
         * 关闭窗体
         */
        onCloseWindow(){
            this.show=false;
            this.$emit("onClose",this.show);
        },
        /**
         * 选择数据
         */
        onConfirm(){

        },
        //确定所选
        selectMattersOk(){
            
        }        
    },
    data(){
        return{
            show:this.defaultShow,
            toBody:this.appendToBody
        }
    }
}
</script>